<div class="flex-fill d-flex flex-column recent-invoices">
    <div *ngIf="invoices" class="d-flex">
        <div class="column ms-2 me-3"><span class="color-legend uncomplete"></span> - UnCompleted Details</div>
        <div class="column ms-2 me-3"><span class="color-legend invoice-ready-to-export"></span> - Ready To Export</div>
        <div class="column ms-2 me-3"><span class="color-legend invoice-update-ready-to-export"></span> - Modified Invoice</div>
    </div>
    <div *ngIf="invoices" class="m-1 grid-fill">
        <dx-data-grid
            #dataGrid
            [dataSource]="invoices"
            keyExpr="id"
            [columnAutoWidth]="false"
            (onToolbarPreparing)="onToolbarPreparing($event)"
            (onSelectionChanged)="selectionChange($event)"
            (onCellDblClick)="rowDoubleClick($event)"
            (onOptionChanged)="onOptionChanged($event)"
            (onContentReady)="onContentReady($event)"
            (onExporting)="onExporting($event)"
            (onRowPrepared)="rowPrepare($event)"
        >
            <dxi-column dataField="id" width="60"></dxi-column>
            <dxi-column dataField="invoiceNumber" caption="Invoice #" width="80" cellTemplate="printTemplate"></dxi-column>
            <dxi-column dataField="packingSlipList" caption="Slip #" width="80" cellTemplate="printTemplate"></dxi-column>
            <dxi-column dataField="dealer.companyName" caption="Dealer" width="200"></dxi-column>
            <dxi-column dataField="subTotal" caption="SubTotal" width="100" [format]="{ type: 'currency', precision: 2 }"></dxi-column>
            <dxi-column dataField="freight" width="100" [format]="{ type: 'currency', precision: 2 }"></dxi-column>
            <dxi-column dataField="tax" caption="Tax" width="100" [format]="{ type: 'currency', precision: 2 }"></dxi-column>
            <dxi-column dataField="feesTotal" caption="Fees" width="100" [format]="{ type: 'currency', precision: 2 }"></dxi-column>
            <dxi-column dataField="invoiceTotal" caption="InvoiceTotal" width="100" [format]="{ type: 'currency', precision: 2 }"></dxi-column>
            <dxi-column dataField="paymentsTotal" caption="Payments" width="100" [format]="{ type: 'currency', precision: 2 }"></dxi-column>
            <dxi-column dataField="invoiceBalance" caption="Balance" width="100" [format]="{ type: 'currency', precision: 2 }"></dxi-column>
            <dxi-column dataField="paid" caption="Paid" width="100"></dxi-column>
            <dxi-column dataField="quickBooksId" width="80"></dxi-column>
            <dxi-column dataField="quickBooksLastExport" caption="Exported" [format]="{ type: 'shortDateShortTime' }" width="100"></dxi-column>
            <dxi-column dataField="readyToExport" caption="ReadyToExport" width="100"></dxi-column>
            <dxi-column dataField="statusDisplay" caption="Detail Status" width="150"></dxi-column>
            <dxi-column dataField="dealer.salesRep.name" caption="Sales Rep" width="150"></dxi-column>
            <dxi-column dataField="dealer.email" caption="Email" width="200"></dxi-column>
            <dxi-column dataField="emailed" width="100"></dxi-column>
            <dxi-column dataField="deliveryMethod" width="125"></dxi-column>
            <!-- <dxi-column dataField="totalCalc" caption="Total" width="100" [format]="{ type: 'currency', precision: 2 }"></dxi-column> -->
            <dxi-column dataField="created" caption="Created" dataType="date" width="100"></dxi-column>
            <dxi-column dataField="ordersListString" caption="Orders" width="180" cellTemplate="ordersTemplate"></dxi-column>
            <dxi-column dataField="status.name" caption="Invoice Status" width="100"></dxi-column>
            <dxi-column dataField="" width="25"></dxi-column>

            <dxo-search-panel class="d-none d-sm-block" [visible]="true"></dxo-search-panel>
            <dxo-export [enabled]="true" [allowExportSelectedData]="true"></dxo-export>
            <dxo-filter-row [visible]="true"></dxo-filter-row>
            <dxo-state-storing [enabled]="true" type="localStorage" storageKey="invoice-search-grid"></dxo-state-storing>
            <dxo-selection [mode]="'multiple'"></dxo-selection>

            <div *dxTemplate="let cell of 'ordersTemplate'">
                <a *ngFor="let invoiceNumber of cell.data.ordersList" [routerLink]="[]" (click)="openInvoiceOrder(invoiceNumber)">{{ invoiceNumber || '' }} </a>
            </div>

            <div *dxTemplate="let cell of 'printTemplate'">
                <a [routerLink]="[]" (click)="printHyperlink(cell)">{{ cell.value || '' }}</a>
            </div>

            <div *dxTemplate="let data of 'toolbarButtons'">
                <button
                    class="btn btn-sm btn-success"
                    (click)="openInvoice(dataGrid.instance.getSelectedRowsData()[0].id)"
                    [disabled]="dataGrid.instance.getSelectedRowsData().length !== 1"
                >
                    Open
                </button>
                <button
                    class="btn btn-sm btn-success ms-2"
                    (click)="readyToExport()"
                    [disabled]="dataGrid.instance.getSelectedRowsData().length === 0 || dataGrid.instance.getSelectedRowsData()[0].quickBooksId !== null"
                >
                    Ready To Export
                </button>

                <button class="btn btn-sm btn-success ms-3" (click)="emailInvoice()" [disabled]="dataGrid.instance.getSelectedRowsData().length !== 1">Email Invoice</button>
                <button class="btn btn-sm btn-success ms-2" (click)="print('Invoice')" [disabled]="dataGrid.instance.getSelectedRowsData().length === 0">Print Invoice</button>
                <!-- <button class="btn btn-sm btn-danger ms-4" (click)="receivePayment()" [disabled]="dataGrid.instance.getSelectedRowsData().length !== 1">Receive Payment</button>
                <button class="btn btn-sm btn-primary ms-2" (click)="updateStatus()">Change Status</button>
                <button class="btn btn-sm btn-secondary ms-2" (click)="payWithoutQuickBooks()" [disabled]="dataGrid.instance.getSelectedRowsData().length === 0">
                    Pay w/o QuickBooks
                </button> -->
                <button class="btn btn-sm btn-secondary ms-2" (click)="getData()">Refresh Data</button>
            </div>
            <div *dxTemplate="let data of 'toolbarText'">
                <span *ngIf="invoices" class="me-3"
                    ><strong
                        >{{ dataGrid.instance.totalCount() + ' items' }}
                        {{ dataGrid.instance.getSelectedRowsData().length > 0 ? dataGrid.instance.getSelectedRowsData().length + ' selected' : '' }}
                    </strong></span
                >
            </div>
        </dx-data-grid>
    </div>
</div>
